import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { getProcedure } from "../../api/procedure";
import { getStage } from "../../api/stage";
import Report from "../../components/Stages/Report/Report";
import { useTranslationHook } from "../../hooks";
import { setLoading } from "../../store/UI";
import { Procedure } from "../../types/model/procedure";
import { Stage } from "../../types/model/stage";

const StageReport = () => {
  const { t } = useTranslationHook();
  const dispatch = useDispatch();

  const { accountId, projectId, activityId, procedureId, stageId } =
    useParams<{
      accountId: string;
      projectId: string;
      activityId: string;
      procedureId: string;
      stageId: string;
    }>();
  
  const [stage, setStage] = useState<Stage>();
  const [procedure, setProcedure] = useState<Procedure>();
  const [loadingLocal, setLoadingLocal] = useState(true);

  const session = JSON.parse(localStorage.getItem("session") || "{}");
  const currentUserId = session?.userId || null;

  useEffect(() => {
    const fetchData = async () => {
      if (!projectId || !activityId || !procedureId || !stageId) return;

      dispatch(setLoading(true));

      try {
        const [
          stageRes,
          procedureRes,
        ] = await Promise.all([
          getStage(Number(projectId), Number(activityId), Number(procedureId), Number(stageId)),
          getProcedure(Number(projectId), Number(activityId), Number(procedureId)),
        ]);

        setStage(stageRes);
        setProcedure(procedureRes);

        enqueueSnackbar(t("stages.report.report-loaded"), {
          variant: "success",
        });
      } catch (error) {
        console.error(error);
        enqueueSnackbar(t("stages.report.error-loading"), {
          variant: "error",
        });
      } finally {
        dispatch(setLoading(false));
        setLoadingLocal(false);
      }
    };  

    fetchData();
  }, [projectId, activityId, procedureId, stageId, dispatch]);

  if (loadingLocal || !stage || !procedure) return null;

  return (
    <Report
      stage={stage}
      userId={currentUserId}
      accountId={Number(accountId)}
      projectId={Number(projectId)}
      activityId={Number(activityId)}
      procedureId={Number(procedureId)}
      procedure={procedure}
    />
  );
};

export default StageReport;